import { initializeApp } from "firebase/app";
import { getAuth, signOut } from "firebase/auth";
import { doc, getDoc, getFirestore, setDoc } from "firebase/firestore";
import moment from "moment";
import { useEffect, useRef } from "react";
import { Navigate, Route, Routes, useNavigate } from "react-router-dom";
import { ToastContainer } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import ScrollToTop from "./components/ScrollToTop";
import Stripe from "./components/StripeWrapper";
import BookingDetails from "./screens/BookingDetails";
import ConfirmServices from "./screens/ConfirmServices";
import ConfirmationScreen from "./screens/ConfirmationScreen";
import Login from "./screens/Login";
import Services from "./screens/Services";
import SignUp from "./screens/SignUp";
import { fireBaseApi, firebaseConfig } from "./utils/firebaseConfig";

const App = () => {
  const intervalId = useRef(null);
  const navigate = useNavigate();
  initializeApp(firebaseConfig);
  useEffect(() => {
    getIdToken();
  }, []);

  const createUser = async (authUser) => {
    const db = getFirestore();
    const ref = doc(db, "Users", authUser.uid);
    const docSnapshot = await getDoc(ref);

    if (!docSnapshot.exists()) {
      setDoc(ref, {
        FirstName: authUser.displayName,
        LastName: "",
        Email: authUser.email,
        DateCreated: moment().toDate(),

        Area: "",
        Phone: "",
        NotificationToke: "",
      });
    }
  };
  const getIdToken = async () => {
    const auth = getAuth();
    auth.onAuthStateChanged(async (user) => {
      if (user && !user.stsTokenManager.isExpired) {
        tokenRefresh();
        intervalId.current = setInterval(async () => {
          tokenRefresh();
        }, 3528000);
      } else {
        signOut(auth).then((res) => {
          localStorage.clear();
          navigate("/services");
        });
      }
    });
  };

  const tokenRefresh = async () => {
    const auth = getAuth();
    const user = await auth.currentUser;
    const token = localStorage.getItem("token");
    if (token && user !== null) {
      console.log("token refreshed");
      const response = await fireBaseApi.post("", {
        grant_type: "refresh_token",
        refresh_token: user.refreshToken,
      });
      localStorage.setItem("token", response.data.id_token);
    } else {
      clearInterval(intervalId.current);
      localStorage.clear();
    }
  };
  return (
    <>
      <ScrollToTop />
      <ToastContainer />
      <Stripe>
        <Routes>
          <Route path="/" element={<Navigate to="/services" />} />
          <Route path="/login" element={<Login />} />
          <Route path="/signup" element={<SignUp />} />
          <Route path="/services" element={<Services />} />
          <Route path="/confirm-services" element={<BookingDetails />} />
          <Route path="/booking-details" element={<ConfirmServices />} />
          <Route path="/booking-confirmed" element={<ConfirmationScreen />} />
        </Routes>
      </Stripe>
    </>
  );
};

export default App;
